import * as XLSX from "xlsx";

const exportToExcel = (jobs) => {
  if (!jobs || jobs.length === 0) {
    alert("No jobs to export");
    return;
  }

  try {
    // Prepare comprehensive data for Excel export
    const excelData = jobs.map((job, index) => ({
      "#": index + 1,
      "Company Name": job.companyName || "",
      "Job Title": job.jobTitle || "",
      Location: job.location || "",
      "Work Type": job.workType || "",
      "Employment Type": job.employmentType || "",
      "Salary Range": job.salaryRange || "",
      "Experience Level": job.experienceLevel || "",
      "Skills Required": job.skillsRequired
        ? job.skillsRequired.join(", ")
        : "",
      "Job Description": job.jobDescription || "",
      "Posted Date": job.postedDate
        ? new Date(job.postedDate).toLocaleDateString()
        : "",
      "Application Deadline": job.applicationDeadline
        ? new Date(job.applicationDeadline).toLocaleDateString()
        : "",
      "Application Status": job.applicationStatus || "",
      "Date Applied": job.dateApplied
        ? new Date(job.dateApplied).toLocaleDateString()
        : "",
      Priority: job.priority || "",
      Notes: job.notes || "",
      Tags: job.tags ? job.tags.join(", ") : "",
      "Date Added": job.dateAdded
        ? new Date(job.dateAdded).toLocaleDateString()
        : "",
      "Job URL": job.jobUrl || "",
      "Days Since Applied": job.dateApplied
        ? Math.floor(
            (new Date() - new Date(job.dateApplied)) / (1000 * 60 * 60 * 24),
          )
        : "",
      "Days Until Deadline": job.applicationDeadline
        ? Math.ceil(
            (new Date(job.applicationDeadline) - new Date()) /
              (1000 * 60 * 60 * 24),
          )
        : "",
      "Has Interview": [
        "Interview Scheduled",
        "Interview Completed",
        "Offer Received",
      ].includes(job.applicationStatus)
        ? "Yes"
        : "No",
      "Is Active": !["Rejected", "Withdrawn"].includes(job.applicationStatus)
        ? "Yes"
        : "No",
    }));

    // Create workbook
    const ws = XLSX.utils.json_to_sheet(excelData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Job Applications");

    // Set column widths for better readability
    const colWidths = [
      { wch: 5 }, // #
      { wch: 20 }, // Company Name
      { wch: 25 }, // Job Title
      { wch: 20 }, // Location
      { wch: 15 }, // Work Type
      { wch: 15 }, // Employment Type
      { wch: 15 }, // Salary Range
      { wch: 15 }, // Experience Level
      { wch: 30 }, // Skills Required
      { wch: 50 }, // Job Description
      { wch: 12 }, // Posted Date
      { wch: 18 }, // Application Deadline
      { wch: 18 }, // Application Status
      { wch: 12 }, // Date Applied
      { wch: 10 }, // Priority
      { wch: 30 }, // Notes
      { wch: 20 }, // Tags
      { wch: 12 }, // Date Added
      { wch: 50 }, // Job URL
      { wch: 15 }, // Days Since Applied
      { wch: 18 }, // Days Until Deadline
      { wch: 12 }, // Has Interview
      { wch: 10 }, // Is Active
    ];
    ws["!cols"] = colWidths;

    // Make URLs clickable
    const urlColumn = excelData[0]
      ? Object.keys(excelData[0]).indexOf("Job URL")
      : -1;
    if (urlColumn !== -1) {
      for (let i = 0; i < excelData.length; i++) {
        const url = excelData[i]["Job URL"];
        if (url && url.startsWith("http")) {
          const cellAddress = XLSX.utils.encode_cell({
            r: i + 1,
            c: urlColumn,
          });
          if (!ws[cellAddress]) ws[cellAddress] = {};
          ws[cellAddress].l = {
            Target: url,
            Tooltip: "Click to open job posting",
          };
        }
      }
    }

    // Add summary statistics sheet
    const summaryData = {
      "Total Jobs": jobs.length,
      "Applied Jobs": jobs.filter((j) => j.applicationStatus !== "Not Applied")
        .length,
      Interviews: jobs.filter((j) =>
        [
          "Interview Scheduled",
          "Interview Completed",
          "Offer Received",
        ].includes(j.applicationStatus),
      ).length,
      Offers: jobs.filter((j) => j.applicationStatus === "Offer Received")
        .length,
      Rejected: jobs.filter((j) => j.applicationStatus === "Rejected").length,
      "Active Applications": jobs.filter(
        (j) => !["Rejected", "Withdrawn"].includes(j.applicationStatus),
      ).length,
      "Export Date": new Date().toLocaleDateString(),
      "Date Range":
        jobs.length > 0
          ? `${new Date(Math.min(...jobs.map((j) => new Date(j.dateAdded || Date.now())))).toLocaleDateString()} - ${new Date().toLocaleDateString()}`
          : "N/A",
    };

    const wsSummary = XLSX.utils.json_to_sheet([summaryData]);
    wsSummary["!cols"] = [{ wch: 25 }, { wch: 15 }];
    XLSX.utils.book_append_sheet(wb, wsSummary, "Summary");

    // Generate filename with current date and job count
    const today = new Date().toISOString().split("T")[0];
    const filename = `job-tracker-${jobs.length}-jobs-${today}.xlsx`;

    // Write file
    XLSX.writeFile(wb, filename);

    console.log(`Successfully exported ${jobs.length} jobs to ${filename}`);
    alert(`Successfully exported ${jobs.length} jobs to ${filename}`);
  } catch (error) {
    console.error("Error exporting to Excel:", error);
    throw new Error("Failed to export to Excel");
  }
};

export { exportToExcel };
